module.exports = __webpack_public_path__ + "static/media/loader-flightStatus-result.96d8147a.svg";